// import { get, post, url} from '../service/ApiDecorator'
import { get, fetch, post, url} from '../http'


class Home {
//轮播图
    @url('banner/list')
    @get
    getBanner(){}

//联系我们
    @url('footer/contact')
    @get
    getFooterInfo(){}
    
//底部二维码
    @url('footer/qrCode')
    @get
    getQRcode(){}

//友情链接
    @url('footer/links')
    @get
    getLinks(){}

//教育资讯
    @url('article/list')
    @get
    getArticleList(){}

//文章详情
    @url('article/detail')
    @fetch
    getArticleDetail(){}

//查询文章头
    @url('article')
    @fetch
    getArticleHead(){}

//获取上下篇文章
    @url('article/preAndNext')
    @fetch
    getPrevAndNext(){}


    //获取各个列表
    @url('news/list')
    @get
    getNewsList(){}

    //用户提交留言
    @url('teacher_train/comment')
    @post
    getComment(){}

     //详情信息
     @url('news/one')
     @get
     getDetail(){}

      //详情信息
      @url('tea/list')
      @get
      getTeaList(){}

      //详情信息
      @url('news/getList')
      @get
      getList(){}
}





export default new Home()
